import scoreStore from "./score";
import sceneStore from "./scene";

export default {
    ScoreStore: scoreStore,
    SceneStore: sceneStore,
}